import { createSelector } from '@ngrx/store';

import { UnnumberedCitation } from '../../models';
import { getCitation } from './get.citations';

export const getUnnumberedCitations = createSelector(
  [getCitation],
  ({ unnumbered_references }): UnnumberedCitation[] => unnumbered_references
);
